import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getApiQueries } from '../../apiSelector'
import { QuerySubStateWithPersist } from '../types/QuerySubStateWithPersist'

export default function usePersistedDataState() {
  const queries = useSelector(getApiQueries)
  const queriesWithPersist = useMemo(() => {
    return Object.values(queries ?? {})
      .map((query) => query as QuerySubStateWithPersist)
      .filter((query) => {
        const querySubState = query as QuerySubStateWithPersist
        return querySubState.fulfilledTimeStampDuringPersist !== undefined
      })
  }, [queries])
  const isDataStale = useMemo(() => {
    const stale = queriesWithPersist.filter((query) => {
      const querySubState = query as QuerySubStateWithPersist
      if (querySubState.startedTimeStamp === -1) {
        return false
      }
      return querySubState.fulfilledTimeStampDuringPersist === querySubState.fulfilledTimeStamp
    })
    return stale.length > 0
  }, [queriesWithPersist])

  const queriesWithErrors = useMemo(() => {
    return queriesWithPersist.filter((query) => {
      const querySubState = query as QuerySubStateWithPersist
      const isRefreshedQuery =
        querySubState.startedTimeStamp !== -1 ||
        querySubState.fulfilledTimeStampDuringPersist !== querySubState.fulfilledTimeStamp
      return isRefreshedQuery && querySubState.status === 'rejected'
    })
  }, [queriesWithPersist])

  const lastUpdatedTime = useMemo(() => {
    if (queriesWithErrors.length === 0) {
      return null
    }
    const maxTime = queriesWithErrors.reduce((max, query) => {
      const querySubState = query as QuerySubStateWithPersist
      return Math.max(max, querySubState.fulfilledTimeStamp ?? 0)
    }, 0)
    return maxTime > 0 ? maxTime : null
  }, [queriesWithErrors])
  return {
    isDataStale,
    hasError: queriesWithErrors.length > 0,
    lastUpdatedTime,
  }
}
